<template>
  <div class="about">
		<div class="pg-header">
			<div>
				<label class="title">疾病管理师工作量统计</label>
			</div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>统计管理</span>|
					<span>工作量统计</span>|
					<span>门诊随访统计</span>|
					<span v-text="depName"></span>
				</div>
				<a class="back noline" @click="goBack">返回</a>
			</div>
		</div>

		<div class="collapse-wrap">
			<div class="search-bar">
				<el-form ref="form" label-width="120px">
					<div class="def-key">
						<label>应随访日期
							<el-date-picker size="small" style="width:220px" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.date" :picker-options="pickerOptions" @change="handleFilter(0, $event)"></el-date-picker>
						</label>
						<label>就诊日期
							<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.outdate" :picker-options="pickerOptions" @change="handleFilter(3, $event)"></el-date-picker>
						</label>
						<div style="display: inline-block;">疾病管理师
							<el-select size="small" filterable clearable placeholder="请选择" v-model="filter.diseaseManagerId" @change="handleFilter(1, $event)">
								<el-option v-for="item in managerList" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</div>	
						<el-button size="mini" icon="el-icon-search" round @click="handleFilter">搜索</el-button>
						<el-button v-if="permission" class="btn-export flr" size="mini" round @click="exportReport"><i class="icon-export" style="margin-right: 10px;"></i>导出</el-button>					</div>
				</el-form>
			</div>

			<div class="table-wrap">
				<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border show-summary :summary-method="getSummaries" :data="list.data" v-loading="isLoading" @selection-change="selectionChange">
					<el-table-column label="科室" prop="depName" width="280"></el-table-column>
					<el-table-column prop="diseaseManager" label="疾病管理师"></el-table-column>
					<el-table-column label="已随访人次">
						<el-table-column prop="followupFinishedFirstTotal" label="首次"></el-table-column>
						<el-table-column prop="followupFinishedSecondTotal" label="二次"></el-table-column>
						<el-table-column prop="followupFinishedThreeMoreTotal" label="三次及以上"></el-table-column>
						<el-table-column prop="followupFinishedTotal" label="合计"></el-table-column>
					</el-table-column>
					<el-table-column prop="shutdownTotal" label="终止随访"></el-table-column>
					<el-table-column prop="validTotal" label="有效随访"></el-table-column>
					<el-table-column prop="validRate" label="有效占比"></el-table-column>
					<el-table-column prop="invalidTotal" label="无效随访人次"></el-table-column>
					<el-table-column label="无效随访原因">
						<el-table-column prop="reason1" label="未接"></el-table-column>
						<el-table-column prop="reason2" label="关机"></el-table-column>
						<el-table-column prop="reason3" label="电话不通"></el-table-column>
						<el-table-column prop="reason4" label="长时间超过10次无人接听"></el-table-column>
						<el-table-column prop="reason5" label="停机"></el-table-column>
						<el-table-column prop="reason6" label="空号"></el-table-column>
						<el-table-column prop="reason7" label="错号"></el-table-column>
						<el-table-column prop="reason8" label="拒接"></el-table-column>
						<el-table-column prop="reason9" label="修改号"></el-table-column>
						<el-table-column prop="reason10" label="其他"></el-table-column>
					</el-table-column>
				</el-table>	
				<div class="pagination">
					<el-row>
						<el-col :span="12">
							<div class="record">当前是第<span v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span v-text="Math.min(list.total, (filter.pageNumber - 1) * filter.pageSize + filter.pageSize)"></span>数据</div>
							<div class="record">总计<span v-text="list.total"></span>条记录</div>
						</el-col>
						<el-col :span="12" style="text-align: right;">
							<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"  prev-text="上一页" next-text="下一页" :current-page="list.current" :page-size="filter.pageSize" :total="list.total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
						</el-col>
					</el-row>
				</div>
			</div>				
				
		</div>

  </div>
</template>

<script>
import api from '@/service/api.js';
import mixin from '@/views/mixin';
import dayjs from 'dayjs';


export default {
  mixins: [mixin],
	data(){
		return {
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null,
				summary: []
			},
			filter: {
				followupTimeStart: '',
				followupTimeEnd: '',
				depId: '',
				diseaseManagerId: '',
				pageNumber: 1,
				pageSize: 10,
				outHospitalTimeEnd:'',
				outHospitalTimeStart:''
			},
			depName: '',
			managerList: [],
			permission:false
		}
	},
	created() {
		this.filter.depId = this.$route.query.depId ?  +this.$route.query.depId : '';
		this.loadList();
		// 获取 疾病管理师下拉
		api.getUserList({roleId: 4}).then((res)=>{
			if (res.code == 1000 && res.data) {
				this.managerList = res.data;
			}
		})
	},	
	methods: {
		async loadList() {
			this.isLoading = true;
			let res = await api.getOutpatientDMList(this.filter);
			if (res.code == 500) {return this.$router.push({name: 'Login', query: {r: location.href}});}
			this.depName = res.data.depName;
			
			this.list.total = +res.total;
			this.list.current = this.filter.pageNumber;
			this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
			if (res.code == 1000 && res.data) {
				this.list.summary = ['合计', res.data.sum.diseaseManager, res.data.sum.followupFinishedFirstTotal,res.data.sum.followupFinishedSecondTotal,res.data.sum.followupFinishedThreeMoreTotal,res.data.sum.followupFinishedTotal, res.data.sum.invalidTotal, res.data.sum.validTotal, res.data.sum.validRate, res.data.sum.shutdownTotal,res.data.sum.reason1,
						res.data.sum.reason2,res.data.sum.reason3,res.data.sum
						.reason4,res.data.sum.reason5,res.data.sum.reason6,
						res.data.sum.reason7,res.data.sum.reason8,res.data.sum
						.reason9,res.data.sum.reason10];
				this.list.data = res.data.list;
			}
			// 权限控制
			this.user = JSON.parse(localStorage.getItem('user')).data;
			this.permission = (this.user.user.roleId == "6" || this.user.user.roleId == "1") ? true : false;
			this.isLoading = false;
		},
		getSummaries() {
			this.$nextTick(() => {
				this.$refs['multipleTable'].doLayout();
			});
			return this.list.summary;
		},
		// 过滤条件 更改
		handleFilter(key, val) {
			switch(key) {
				case 0:
					if (this.filter.date) {
						this.filter.followupTimeStart = dayjs(this.filter.date[0]).format('YYYY-MM-DD 00:00:00');
						this.filter.followupTimeEnd = dayjs(this.filter.date[1]).format('YYYY-MM-DD 23:59:59');
					} else {
						this.filter.followupTimeStart = '';
						this.filter.followupTimeEnd = '';						
					}
					break;
					case 3:
					if (this.filter.outdate) {
						this.filter.outHospitalTimeStart = dayjs(this.filter.outdate[0]).format('YYYY-MM-DD 00:00:00');
						this.filter.outHospitalTimeEnd	 = dayjs(this.filter.outdate[1]).format('YYYY-MM-DD 23:59:59');
					} else {
						this.filter.outHospitalTimeStart = '';
						this.filter.outHospitalTimeEnd = '';						
					}
					break;
			}
			this.filter.pageNumber = 1;
			this.loadList();
		},			
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		},
		exportReport() {
			this.filter.pageSize=this.list.total;
			let url = api.exportStatisticsManage2(this.filter);
			const tempLink = document.createElement('a');
			tempLink.style.display = 'none';
			tempLink.href = url;
			tempLink.target = '_blank';
			document.body.appendChild(tempLink);
			tempLink.click()
			document.body.removeChild(tempLink);
			this.filter.pageSize=10;

		}
	}
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';
</style>
